import * as Sentry from '@sentry/browser';
import { BalanceManagerApiService } from '@/services/api';
import type { BankSlipType } from './types';

type useUpcomingBankSlipType = {
  getUpcomingBankSlips: (contractId: string) => Promise<BankSlipType[]>;
};

function useUpcomingBankSlip(): useUpcomingBankSlipType {
  const { api } = BalanceManagerApiService();

  async function getUpcomingBankSlips(
    contractId: string,
  ): Promise<BankSlipType[]> {
    try {
      const { data } = await api.get<BankSlipType[]>(
        `/external/v1/contract/${contractId}/bank_slips/upcoming`,
      );

      return data;
    } catch (error) {
      Sentry.captureException(error, {
        extra: {
          message:
            "Attempt to retrieve upcoming bank slips ended in failure, possibly due to the absence of the contract's id",
        },
      });
    }

    return [];
  }

  return { getUpcomingBankSlips };
}

export default useUpcomingBankSlip;
